var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"root fixed w-screen h-full z-20"},[_c('div',{ref:"loadingAnimation",staticClass:"loading-wrapper w-3/5 my-0 mx-auto"})])}
var staticRenderFns = []

export { render, staticRenderFns }